const types = {
    ALL_AGENDAMENTO: '@agendamento/ALL',
    UPDATE_HORARIOS_DISPONIVEIS: '@agendamento/UPDATE-HORARIOS-DISPONIVEIS',
    GET_HORARIOS_DISPONIVEIS: '@agendamento/horariosDisponiveis',
    FILTER_AGENDAMENTO: '@agendamento/FILTER',
    UPDATE_AGENDAMENTO: '@agendamento/UPDATE',
    UNLINK_AGENDAMENTO: '@agendamento/UNLINK',
    UPDATE_COMPONENT: '@agendamento/UPDATE_COMPONENT'
}

export default types